export enum ClaimType {
    "Price Claim" = 1,
    "Inventory Claim" = 2,
    "Uplift Request" = 3,
    "RMA" = 4,
    "Ad Hoc" = 5
}